import store from '../store/index'
export default class lsSync {
  static syncData () {
    const featuresStatus = localStorage.getItem('featuresStatus')
    let featureStatusObject = JSON.parse(featuresStatus)
    let defaultFeaturesStatus = {
      magnify_cursor: false,
        brightness: 0,
        disable_animation: false,
        legible_font: false,
        font_size: 0,
        reading_guide: false,
        highlight_links: false,
        letter_spacing: 0,
        text_magnify: false,
        text_to_speech: false,
        highlight_titles: false,
        tool_tip: false,
        speechToText: false,
        textToSpeechLang: 'current',
        speechToTextLang: {
        source: 'en',
          target: 'en'
      }
    }
    if (featureStatusObject) {

      store.dispatch('setFeatureStatues',{...defaultFeaturesStatus, ...featureStatusObject})
    }

  }
}
